export interface ForumUser {
    userId: string
    firstname: string
    lastname: string
    nickname?: string
    avatarImage?: string
    role?: string
}

export interface CommentsAttachment {
    file: File
    id: string
    url: string
}

export interface ForumMessage {
    userName: string
    userLastname: string
    avatarImage: string
    comment: string
    reactions: string[]
    nickname: string
    alias?: string
    id: string
    messageTime: string
    enableDropdown?: boolean
    hasChildBorderTop?: boolean
    hasChildBorderBottom?: boolean
    hasThirdChildBorderBottom?: boolean
    attachmentList: any[]
    replyList: ForumMessage[]
    isRead: boolean
    showLoadMore?: boolean
    userReaction?: string
}

export enum CommentType {
    FORUM = 'forum',
    PROJECT = 'project',
    RESOURCE = 'resource',
}

export enum UploadFileType {
    PHOTO = 'photo',
    FILE = 'file',
}

export enum ThreadListSort {
    NEWEST_THREAD = 'newest_thread',
    NEWEST_TOPIC = 'newest_topic',
    RECENT_ACTIVITY = 'recent_activity',
    MOST_COMMENTS = 'most_comments',
    TITLE = 'title',
    LATEST_THREAD = 'latest_thread',
    TRENDING = 'trending',
    ASC = 'ASC',
    DESC = 'DESC',
}

export enum ReactionOperation {
    ADD = 'add',
    REMOVE = 'remove',
}
export interface CreateMessageBody {
    text?: string
    attachmentIds?: string[] // undefined or null or []
    isGif: boolean
    reference: {
        threadId?: string
        topicId?: string
        parentId?: string // or undefined or null
        projectId?: string
        storeIdList?: string[]
        documentId?: string
        messageId?: string
    }
    reaction?: string
    reactionOperation?: ReactionOperation
}

export interface PaginationParams {
    sortAction?: ThreadListSort
    pageSize?: number
    pageNum?: number
}

export interface GetMessageParams extends PaginationParams {
    threadId?: string
    topicId?: string
    parentId?: string
    projectId?: string
    storeIdList?: string[]
    documentId?: string
    isDetail?: boolean
}
